import { getClientExtensionProperty } from "../helpers/clientExtensionHelper";

let domainName = window.location.origin;

let client_ID =
  getClientExtensionProperty("clientId");

let client_Secret =
  getClientExtensionProperty("clientSecret");

let isDevelopment = "false";

export const Constants = {
  URL: {
    base: `${domainName}/`,
    auth: "/o/oauth2/token",
    checkValidOtpandpassword:
      "/o/pms-pre-login-custom-headless/v1.0/updatePasswordWithTicket",
    forgotpassword:
      "/o/pms-pre-login-custom-headless/v1.0/trigger-forgot-password",
  },

  publicPath: {
    localServer: "images/",
    productionServer: "/documents/d/partner-management-system/",
  },
  client: {
    id: client_ID,
    secret: client_Secret,
  },
  isDevelopment,
};
